var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 22,
    viewBox: "0 0 18 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.464 0H4.136C1.1 0 0 1.1 0 4.191V17.809C0 20.9 1.1 22 4.136 22H13.453C16.5 22 17.6 20.9 17.6 17.809V4.191C17.6 1.1 16.5 0 13.464 0ZM8.8 19.03C7.744 19.03 6.875 18.161 6.875 17.105C6.875 16.049 7.744 15.18 8.8 15.18C9.856 15.18 10.725 16.049 10.725 17.105C10.725 18.161 9.856 19.03 8.8 19.03ZM11 4.675H6.6C6.149 4.675 5.775 4.301 5.775 3.85C5.775 3.399 6.149 3.025 6.6 3.025H11C11.451 3.025 11.825 3.399 11.825 3.85C11.825 4.301 11.451 4.675 11 4.675Z",
    fill: "#A9A7A7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.27a0fb4eb276b6683fb0112b947b2cf7.svg";
export { ForwardRef as ReactComponent };